import React from 'react';
import Hero from '../components/Hero';
import Skills from '../components/Skills';
import Certificates from '../components/Certificates';
import ProfessionalSummary from '../components/ProfessionalSummary';

const Home = ({ portfolioData }) => {
  return (
    <div>
      <Hero about={portfolioData.about} />
      <Certificates certificates={portfolioData.certificates} />
      <ProfessionalSummary about={portfolioData.about} />
      <Skills skills={portfolioData.skills} />
      
      {/* Fun Side Projects Section */}
      <section className="py-16 bg-dark-900">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-white mb-4">Fun Side Projects</h2>
            <p className="text-gray-400 max-w-2xl mx-auto">
              Experiments, prototypes, and slightly less formal builds.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {portfolioData.projects.slice(0, 3).map((project) => (
              <div key={project.id} className="bg-dark-700 rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300">
                {project.image && (
                  <img src={project.image} alt={project.title} className="w-full h-48 object-cover" />
                )}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-white mb-2">{project.title}</h3>
                  <p className="text-gray-300 mb-4">{project.description}</p>
                  <div className="flex flex-wrap gap-2 mb-4">
                    {project.technologies.map((tech, index) => (
                      <span key={index} className="bg-dark-600 text-xs text-primary-300 px-2 py-1 rounded">
                        {tech}
                      </span>
                    ))}
                  </div>
                  <div className="flex space-x-4">
                    {project.github_url && (
                      <a
                        href={project.github_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary-400 hover:text-primary-300 transition"
                      >
                        GitHub
                      </a>
                    )}
                    {project.live_url && (
                      <a
                        href={project.live_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary-400 hover:text-primary-300 transition"
                      >
                        Live Demo
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      {/* Articles Section */}
      <section className="py-16 bg-dark-800">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-white mb-4">Latest Articles</h2>
            <p className="text-gray-400 max-w-2xl mx-auto">Technical writing on cloud infrastructure, security, and automation</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {portfolioData.articles.slice(0, 3).map((article) => (
              <a
                key={article.id}
                href={article.url}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-dark-700 rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
              >
                {article.image && (
                  <img src={article.image} alt={article.title} className="w-full h-48 object-cover" />
                )}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-white mb-2 hover:text-primary-400 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-gray-400 mb-4">
                    {new Date(article.published_date).toLocaleDateString()}
                  </p>
                  <p className="text-gray-300">{article.summary}</p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>
      
      {/* Contact Section */}
      <section className="py-16 bg-dark-900 border-t border-dark-700">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-6">Get In Touch</h2>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Connect with me on LinkedIn, check out my YouTube channel, or get in touch about cloud and security work.
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <a
              href={portfolioData.about.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              LinkedIn
            </a>
            {portfolioData.about.youtube && (
              <a
                href={portfolioData.about.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-outline"
              >
                YouTube
              </a>
            )}
            <a 
              href={`mailto:${portfolioData.about.email}`}
              className="btn-outline"
            >
              Email Me
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
